// extracted by mini-css-extract-plugin
export default {"block":"Registrations_block__yHBSY"};